import React, {Component} from 'react';
import TandCComponent from '../TandCComponent/TandCComponent';
import HeaderSectionComponent from '../HeaderSectionComponent/HeaderSectionComponent';
import CalloutCardComponent from '../CalloutCardComponent/CalloutCardComponent';
import SignUpComponent from '../SignUpComponent/SignUpComponent';

import './SignUpPageComponent.less';

class SignUpPageComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: '',
            errorTitle: ''
        };
    }

    clearAlert = () => {
        this.setState({error: '', errorTitle: ''});
    };

    handleError = (error) => {
        this.setState({error});
    };

    render() {
        const {lingua, multiUserEnabled} = this.props;
        const {error, errorTitle} = this.state;
        let cardContent = (
            <SignUpComponent handleError={this.handleError} {...this.props} />
        );
        return (
            <div className="border-border-color">
                <HeaderSectionComponent
                    title={lingua.read('lex.header.signup')}
                />
                <CalloutCardComponent
                    content={cardContent}
                    error={error}
                    errorTitle={errorTitle}
                    clearAlert={this.clearAlert}
                />
                <TandCComponent
                    lingua={lingua}
                    multiUserEnabled={multiUserEnabled}
                />
            </div>
        );
    }
}

export default SignUpPageComponent;
